import styled from 'styled-components'
import { Icon, Layout } from 'antd'

import { Image, Menu, MenuSubMenu } from 'src/components/Ant'

export const Language = styled.div`
  color: rgba(255, 255, 255, 0.65);
  font-size: initial;
`

export const LastButtons = styled.span<{ collapsed: boolean }>`
  bottom: 14px;
  left: 0;
  min-height: 100px;
  position: fixed;
  transition: color 0.3s;
  vertical-align: middle;
  width: ${({ collapsed }) => (collapsed ? '200px' : '80px')};
  z-index: 3;
  > div {
    padding: 12px;
    ${({ collapsed }) =>
      collapsed
        ? { paddingLeft: '24px', textAlign: 'left' }
        : { textAlign: 'center' }};
  }
`

export const LogoContainer = styled.div`
  align-items: center;
  background-color: #fff;
  display: flex;
  flex: 1;
  height: 64px;
  justify-content: center;
  margin: 0 0 32px 0;
`

export const LogoIcon = styled(Image)`
  width: 70px;
`

export const LogoName = styled(Image)`
  margin-left: -20px;
  width: 120px;
`

export const Name = styled.div`
  background-color: white;
  font-size: initial;
  font-weight: bold;
  font: inherit;
  padding: 12px 24px;
`

export const QRCodeContainer = styled.div`
  cursor: pointer;
  font-size: 18px;
  height: 425px;
  margin: 0 24px;
  transition: color 0.3s;
  width: 425px;
  &:hover {
    color: #fa8c16;
  }
`

export const QRCodeIcon = styled(Icon)`
  color: #bbb;
  font-size: initial;
  transition: color 0.3s;
  &:hover {
    color: #fa8c16;
  }
`

export const Side = styled(Layout.Sider)`
  background-color: #1d4384;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  z-index: 3;
`

export const SideMenu = styled(Menu)`
  background-color: #1d4384;
`

export const SideMenuText = styled.span`
  color: rgba(255, 255, 255, 0.65);
  > span {
    margin-left: 8px;
  }
`

export const Spin = styled.div`
  text-align: center;
`

export const SubMenu = styled(MenuSubMenu)`
  .ant-menu-inline.ant-menu-sub,
  .ant-menu-sub {
    background-color: #17376f;
  }
`
